module.exports = __webpack_public_path__ + "static/media/chart.f73c984c.svg";